export default "__VITE_ASSET__BZthfLx9__"